// Menu visibility continues to use `roles` (explicit/RoleGroup grants).
// Only workflow selectors should consult inherited capabilities.
export function effectivePermissions() {
  try {
    const context = JSON.parse(localStorage.getItem('permissionContext') || 'null');
    const current = context && context.token === localStorage.getItem('userToken') && context.network === localStorage.getItem('networkId');
    return JSON.parse(localStorage.getItem(current ? 'effectiveRoles' : 'roles') || '[]').map(role => role.toUpperCase());
  } catch (_) { return []; }
}

export function canBrowse(role) {
  const roles = effectivePermissions();
  return roles.includes(role) || (role.endsWith('_READ') && roles.includes(role.replace(/_READ$/, '_BROWSER')));
}

// A picker may need the selected record again. It must not call its full detail
// endpoint with a browser-only permission.
export async function loadLookupRecord(api, resource, id, readRole) {
  if (effectivePermissions().includes(readRole)) return api('get', `/api/v2/${resource}/${id}`);
  const response = await api('get', `/api/v2/browser/${resource}?search[id][operator]==&search[id][value]=${encodeURIComponent(id)}&item_per_page=1`);
  return {...response, data: {...response.data, data: response.data?.data?.items?.[0] || null}};
}
